import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';
import { Layout, SEO, Breadcrumbs } from '../../components';
import { isValidArray } from '../../components/utilities/validations';
import ImageBanner from '../../components/common/image-banner';
import TabbedContent from '../../components/template/window-101/tabbed-content';
import LimitedWarrantyV2 from '../../components/common/footer/limited-warranty-v2';
import DynamicComponent from '../../components/common/dynamic-component';
import CardSection from '../../components/common/card-section';
import LocalNavTop from '../../components/common/local-nav-top';
import HeroSimple from '../../components/common/hero-simple';
import { HoverEmbed } from '../../components/third-party/hover';

const Window101 = (props) => {
	const pageData = props.data.contentstackWindow101;

	return (
		<Layout
			id='template-Window101'
			hideWarranty={true}
		>
			{isValidArray(pageData.local_nav?.nav_links) && (
				<LocalNavTop
					navTitle={pageData.local_nav.heading}
					linksArray={pageData.local_nav.nav_links.map((link) => link.cta[0])}
				/>
			)}

			{pageData.breadcrumb && (
				<Breadcrumbs
					data={pageData.breadcrumb}
					currentUrl={pageData.url}
				/>
			)}

			{isValidArray(pageData.page_hero) && <HeroSimple data={pageData.page_hero[0]} />}

			{isValidArray(pageData?.carousel) &&
				pageData.carousel.map((block, index) => (
					<TabbedContent
						data={block}
						key={index}
					/>
				))}

			{pageData.embed?.embed_id && (
				<div
					id={pageData.embed.anchor_text}
					className='mt-6'
				>
					<HoverEmbed configId={pageData.embed.embed_id} />
				</div>
			)}

			{isValidArray(pageData.image_callout) && <ImageBanner data={pageData.image_callout[0]} />}

			{isValidArray(pageData.cards) &&
				pageData.cards.map((cards, index) => (
					<CardSection
						data={cards}
						key={index}
					/>
				))}

			{isValidArray(pageData.all_dynamic) &&
				pageData.all_dynamic.map((item, index) => (
					<DynamicComponent
						data={item}
						key={index}
					/>
				))}

			{isValidArray(pageData?.warranty) && <LimitedWarrantyV2 data={pageData.warranty[0]} />}
		</Layout>
	);
};

Window101.propTypes = {
	data: PropTypes.object,
	location: PropTypes.object,
};

export default Window101;

// eslint-disable-next-line react/prop-types -- accepted
export const Head = ({ data }) => (
	<SEO
		// eslint-disable-next-line react/prop-types -- accepted
		{...data.contentstackWindow101.seo}
	/>
);

export const query = graphql`
	query ($uid: String!) {
		contentstackWindow101(id: { eq: $uid }) {
			url
			breadcrumb {
				active_page
				back_pages {
					...CTA
				}
			}
			local_nav {
				...LocalNav
			}
			page_hero {
				...NewHero
			}
			carousel {
				heading
				anchor_text
				product {
					carousel_icon {
						file {
							url
							gatsbyImageData(height: 120, quality: 90)
						}
						heading
						subheading
						linkable
						url
					}
					group {
						images {
							...Image
							image {
								gatsbyImageData(width: 735, quality: 90)
							}
						}
						heading
						subheading
						description
						why {
							heading
							group {
								file {
									url
									gatsbyImageData(height: 75, quality: 90)
								}
								heading
							}
							ctas {
								...CTA
							}
						}
					}
				}
				cta_ribbon {
					heading
					cta {
						...CTARibbon
					}
				}
			}
			image_callout {
				...ImageCallout
				image {
					image {
						gatsbyImageData(height: 500, quality: 90)
					}
				}
			}
			all_dynamic {
				heading
				dynamic {
					...Dynamic
				}
			}
			cards {
				...CardSection
			}
			warranty {
				...ImageCallout
				image {
					image {
						gatsbyImageData(height: 300, quality: 90)
					}
				}
			}
			embed {
				anchor_text
				embed_id
			}
			seo {
				title
				description
				noIndex: no_index_page
			}
		}
	}
`;
